import { pixelToVW } from './pixelToVW';
import { pixelToRem } from './pixelToRem';

/**
 * 格式化图片长和宽
 * @param style 样式对象
 * @param imgWidth 三倍图标准下的图片宽度
 * @param imgHeight 三倍图标准下的图片高度
 * @param imgUrl 图片src
 * @param {*} times 倍数 如三倍图则传3  number
 * @param isPc 是否为pc场景 boolean
 */
export function formatImgStyle(
    style = {},
    { imgWidth, imgHeight, imgUrl } = {},
    times = 3,
    isPc = false
) {
    if (imgWidth && imgHeight && imgUrl) {
        style.width = isPc ? pixelToRem(imgWidth) : pixelToVW(imgWidth, times);
        style.height = isPc ? pixelToRem(imgHeight) : pixelToVW(imgHeight, times);
    }
    return style;
}
